import { defineMessages } from 'react-intl';

export default defineMessages({
  admin: {
    id: 'frontbucket.repository.admin.breadcrumbs.repodetails',
    description: 'Text to display for repository settings breadcrumb link',
    defaultMessage: 'Repository settings',
  },
});
